// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.created-illustration__skeleton_size_s {
  height: 100px;
  width: 100px;
}
.created-illustration__skeleton_size_m {
  width: 150px;
  height: 150px;
}
.created-illustration__skeleton_size_l {
  height: 230px;
  width: 230px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Illustration/Illustration.scss"],"names":[],"mappings":"AAMQ;EACI,aANA;EAOA,YAPA;AAEZ;AAQQ;EACI,YAVA;EAWA,aAXA;AAKZ;AASQ;EACI,aAdA;EAeA,YAfA;AAQZ","sourcesContent":[".created-illustration__skeleton_size_s {\n  height: 100px;\n  width: 100px;\n}\n.created-illustration__skeleton_size_m {\n  width: 150px;\n  height: 150px;\n}\n.created-illustration__skeleton_size_l {\n  height: 230px;\n  width: 230px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
